export const dasherize = (string: string | null | undefined) => {
  if (!string) return '';

  return string.replace(/\s/g, '-');

  // * replace all didnt work in the test because babel is not loaded in the test env. if you know how to do it, go ahead
  // return string.replaceAll(' ', '-');
};
